// 大分類列表 - 大分類（全部新聞）、中分類
'use client';

import React, { useEffect, useMemo, useState } from 'react';
import { useParams, usePathname } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { CATEGORY_LIST } from '@/common/constant'; // 中分類

const ClassificationList = ({ initType }) => {
    const pathname = usePathname();
    const params = useParams();
    const { category = 'allnews' } = params;

    const { t } = useTranslation();

    // 目前分類
    const [currentCategory, setCurrentCategory] = useState(
        category === 'allnews' ? 'allnews' : initType
    );

    // 點擊大分類切換
    const onClickCategory = (c) => {
        setCurrentCategory(c);
        // 路徑變更
        window.history.replaceState(null, '', c === 'allnews' ? '/' : c);
    };

    // 防連點
    const clickDebounce = useMemo(() => _.debounce(onClickCategory, 300), [onClickCategory]);

    useEffect(() => {
        return () => clickDebounce.cancel();
    }, [clickDebounce]);

    const handleLocation = () => {
        if (category !== 'allnews') return;

        const regexCategory = /(?:\/cn)?\/([^\/?]+)/;
        const matchCategory = pathname.match(regexCategory);
        if (matchCategory && matchCategory[1] !== currentCategory)
            setCurrentCategory(matchCategory[1]);
    };

    useEffect(() => {
        handleLocation();
    }, [pathname]);

    return (
        <div className="noScrollX w-full">
            <div className="px-[18px] w-max flex items-center gap-x-[2px] ulg:pl-[3px] ulg:pr-[15px]">
                {CATEGORY_LIST.map((tab, i) => (
                    <React.Fragment key={tab + i + 'category'}>
                        {/* 分類按鈕 */}
                        <button
                            onClick={() => clickDebounce(tab.toLowerCase())}
                            className={`gtm-category-${tab} text-btn1 px-[20px] py-[10px] trans underline decoration-transparent
                                ${
                                    currentCategory === tab.toLowerCase()
                                        ? 'text-[#fff] !decoration-[#fff]'
                                        : 'trans text-[#c7c7c7] hover:text-[#fff]'
                                }`}
                        >
                            {t(tab?.toUpperCase())}
                        </button>
                        {i < CATEGORY_LIST?.length - 1 && (
                            <span className="w-[1px] border-l-1 border-[#c7c7c7] h-[10px]" />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default ClassificationList;
